var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/new_mail"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22 6.722C22 3.654 20.346 2 17.278 2H6.722C3.654 2 2 3.654 2 6.722m20 0v10.556C22 20.346 20.346 22 17.278 22H6.722C3.654 22 2 20.346 2 17.278V6.722m20 0-10 8.056L2 6.722M13.463 1l1.315 3.552 3.552 1.315-3.552 1.314-1.315 3.553L12.15 7.18 8.596 5.867l3.553-1.315L13.463 1Zm5.661 11.026 1.058 2.858 2.859 1.058L20.182 17l-1.058 2.859L18.067 17l-2.86-1.058 2.86-1.058 1.057-2.858Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMail);
export default __webpack_public_path__ + "static/media/new_mail.1618518074cff117caef6a3f8849b1f0.svg";
export { ForwardRef as ReactComponent };